import { useQuery, useQueryClient } from "react-query";

export const useUiVersion = () => {
  const { data: uiVersion } = useQuery({
    queryKey: ["uiVersion"],
    queryFn: async () => {
      return new Date().getTime(); // Example version
    },
    refetchOnWindowFocus: false,
  });
  return {
    uiVersion,
  };
};

export const useUiVersionReset = () => {
  const queryClient = useQueryClient();
  return {
    reset: () => {
      queryClient.invalidateQueries({ queryKey: ["uiVersion"] });
      // queryClient.refetchQueries({ queryKey: ["uiVersion"] });
    },
  };
};
